export default __webpack_public_path__ + "static/media/logo-slo.bf83704e.svg";